/** Есть ли у горизонтальной ленты что листать влево и вправо: для стрелок и затемнения краёв. */
import { useCallback, useEffect, useRef, useState } from 'react';

export function useScrollEdges<T extends HTMLElement>(deps: readonly unknown[] = []) {
  const ref = useRef<T>(null);
  const [edges, setEdges] = useState({ left: false, right: false });
  const measure = useCallback(() => {
    const row = ref.current;
    if (!row) return;
    const rest = row.scrollWidth - row.clientWidth - row.scrollLeft;
    const left = row.scrollLeft > 4;
    const right = rest > 4;
    setEdges(prev => prev.left === left && prev.right === right ? prev : { left, right });
  }, []);
  useEffect(() => {
    measure();
    // Стрелки занимают место в ряду; пересчитываем при смене ширины и содержимого.
    const observer = new ResizeObserver(measure);
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [measure, ...deps]);
  /** Классы для маски затемнения у краёв, где есть скрытое содержимое. */
  const fadeClass = 'edge-fade' + (edges.left ? ' fade-left' : '') + (edges.right ? ' fade-right' : '');
  return { ref, edges, measure, fadeClass };
}
